
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { eTimeCard } from '@/interface/time-card.ts';
import { colorList } from '@/utils/colorList';
import { setIOSId } from '@/api/coinManaging';
import { toast } from '@/utils/common';
@Component
export default class extends Vue {
  @Prop({ type: Object, required: true }) info!: any;
  @Prop({ default: false }) isShowPID!: boolean;
  monthType: eTimeCard = eTimeCard.MONTH;
  weekType: eTimeCard = eTimeCard.WEEK;
  checked: boolean = false;
  isUpdate: boolean = false;
  proName: string = '';
  id: number | null = null;
  checkColorItem: object[] = [
    { id: 1, colorS: '#8100ff', colorE: '#8969ff' },
    { id: 2, colorS: '#7800ff', colorE: '#00a2ff' },
  ];
  colorList: object[] = colorList;
  @Emit('change')
  change() {
    return this.info;
  }
  @Emit('edit')
  edit() {
    return this.info;
  }
  @Emit('deleteSubcard')
  deleteSubcard() {
    return this.info;
  }
  getId(name: string) {
    if (name) {
      const str = name.split('.');
      const value = str[str.length - 1];
      str.pop();
      this.proName = str.join('.');
      this.id = JSON.parse(value);
      return value;
    } else {
      this.proName = 'cn.lingwoyun.cloudpc.card';
    }
  }
  async handleSaveID() {
    try {
      if (this.isUpdate) {
        const data = { type: 2, id: this.info.id, apple_product_id: this.proName + '.' + this.id }; //type 1-云币包 2-周期卡
        const res: any = await setIOSId(data);
        if (res && res.code == 0) {
          this.isUpdate = false;
          this.$emit('successSaveIOSId', 2);
          toast('修改成功', 'success');
        } else {
          toast(res.msg, 'error');
        }
      } else {
        this.isUpdate = !this.isUpdate;
      }
    } catch (err) {
      console.log(err);
    }
  }
}
